import React, {useContext, useEffect, useState} from 'react';
import './MillworksContent.scss';
import {ExperienceContext, useStore} from '@thd-nucleus/experience-context';
import {RevJetTag} from '@revjet/react-revjet-tag';

const MillworksContent = ({opts}) => {
  const { storeId } = useStore({ varnish: false });
  const { channel } = useContext(ExperienceContext);
  const [ runTagProperties, setRunTagProperties ] = useState();
  useEffect(() => {
    if(storeId) {
      setRunTagProperties(initializeMillworks(storeId, channel, opts));
    }
  }, [storeId]);
  useEffect(() => {
    return () => {
      removeExtraRevjetScripts();
    };
  }, []);
  return runTagProperties ? <RevJetTag tagProperties={runTagProperties} /> : null;
};

export const initializeMillworks = (storeId, channel, opts) => {
  const defaultChannelConfig = getDefaultChannelConfig(channel);
  const userChannelConfig = getUserChannelConfig(opts, channel);
  const finalConfig = {...defaultChannelConfig, ...userChannelConfig};
  if(finalConfig) {
      return {
        _tag: finalConfig.tagId,
        _plc_id: finalConfig.placementId,
        _key: finalConfig.key,
        _opts: {
          embd_tag_id: (function(doc) {
            var tag = doc.createElement("div");
            tag.id = 'revjet-tag-' + ((window.revjet || {}).tags || []).length;
            var s = doc.getElementsByTagName("script");
            s[s.length-1].parentNode.insertBefore(tag, s[s.length-1]);
            return tag.id;
          })(document),
          custom_domain: finalConfig.customDomain,
          responsive: finalConfig.responsive,
          autoscale: finalConfig.autoscale,
          delivery_method: finalConfig.deliveryMethod,
          _imp_banner_size: finalConfig.size
        },
        thd_store_id: storeId
  };
  }
}

export const getDefaultChannelConfig = (channel) => {
  const defaults = {
    responsive: false,
    autoscale: true,
    deliveryMethod: 'banner',
    customDomain: 'rma.homedepot.com'
  }
  const config = {
    mobile: {
      placementId: '48146786',
      size: '375x450',
      tagId: 'tag154512',
      key: '298'
    },
    desktop: {
      placementId: '48146666',
      size: '1420x350',
      tagId: 'tag154511',
      key: '4c3'
    }
  }
  return {...defaults, ...config[channel]};
}
export const getUserChannelConfig = (opts, channel) => {
  if (opts?.config?.config) {
    return {...opts.config.config[channel]};
  }
}
export const removeExtraRevjetScripts = () => {
  const revjetDiv = document.querySelector('[id^="revjet-tag-"]');
  const revjetScript = document.getElementById('revjet-id');
  if (revjetDiv) {
    revjetDiv.remove();
  }
  if (revjetScript) {
    revjetScript.remove();
  }
}
export default MillworksContent;
